import {
    createListTableColumns,
    ListTableColumn,
    renderDate,
    renderDateTime,
    renderTextWithTooltip
} from "sprint-common-web";

import { getCiCloudFileQcReviewPageHref } from "../../ContentIngestionRoutes";
import { CloudFileStatus } from "../common/types/CloudFileStatus";
import { renderCloudFileStatus } from "../common/utils/renderCloudFileStatus";
import { CloudFileActionsListingButtons } from "./actions/CloudFileActionsListingButtons";
import { CloudFileListingItem } from "./types/CloudFileListingItem";
import { renderIsCloudFileNotificationApproved } from "./utils/renderIsCloudFileNotificationApproved";
import { renderLastUpdatedBy } from "./utils/renderLastUpdatedBy";

export const createCloudFileListingColumns = (): ListTableColumn<CloudFileListingItem>[] => {
    return createListTableColumns<CloudFileListingItem>([
        {
            type: "link",
            key: "deliveryFileName",
            name: "File name",
            minWidth: 65,
            maxWidth: 350,
            isSortable: true,
            isDisabled: (item) => isDeliveryFileNameDisabled(item),
            getHref: (item) => getCiCloudFileQcReviewPageHref(item.id),
            getTooltipText: (item) => item.deliveryFileName
        },
        {
            type: "basic",
            key: "filePath",
            name: "File path",
            minWidth: 65,
            maxWidth: 350,
            isSortable: true,
            onRender: renderTextWithTooltip
        },
        {
            type: "basic",
            key: "deliveryRef",
            name: "Reference",
            minWidth: 65,
            maxWidth: 80,
            isSortable: true
        },
        {
            type: "basic",
            key: "deliveryType",
            name: "Delivery type",
            minWidth: 90,
            maxWidth: 90,
            isSortable: false
        },
        {
            type: "basic",
            key: "originator",
            name: "Originator",
            minWidth: 70,
            maxWidth: 110,
            isSortable: true
        },
        {
            type: "basic",
            key: "status",
            name: "Status",
            minWidth: 100,
            maxWidth: 120,
            isSortable: true,
            onRender: renderCloudFileStatus
        },
        {
            type: "basic",
            key: "isNotificationApproved",
            name: "Buzz notifications",
            minWidth: 120,
            maxWidth: 120,
            isSortable: false,
            onRender: renderIsCloudFileNotificationApproved
        },
        {
            type: "basic",
            key: "arrivalDate",
            name: "Arrival date",
            minWidth: 120,
            maxWidth: 120,
            isResizable: false,
            isSortable: true,
            onRender: renderDate
        },
        {
            type: "basic",
            key: "updateDate",
            name: "Update date",
            minWidth: 120,
            maxWidth: 120,
            isResizable: false,
            isSortable: false,
            onRender: renderDateTime
        },
        {
            type: "basic",
            key: "lastUpdatedBy",
            name: "Last updated by",
            minWidth: 120,
            maxWidth: 120,
            isResizable: false,
            isSortable: true,
            onRender: renderLastUpdatedBy
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 200,
            maxWidth: 200,
            isResizable: false,
            buttons: [
                {
                    id: "actions",
                    render: CloudFileActionsListingButtons
                }
            ]
        }
    ]);
};

const isDeliveryFileNameDisabled = (item?: CloudFileListingItem) => {
    return (
        item?.status === CloudFileStatus.PrepQcFailed ||
        item?.status === CloudFileStatus.PrepForQc ||
        item?.status === CloudFileStatus.Rejected
    );
};
